// eslint-disable-next-line import/prefer-default-export
import { getImages } from 'store/browse-items/selectors';

export const getItem = ({ item }) => ({
  ...item.data,
  images: getImages(item.data?.images || []),
});

export const getNextItem = ({ item }) => item.nextData;
export const getItemsLoading = ({ item }) => item.loading;
export const getItemsLikeLoading = ({ itemLikes }) => itemLikes.loading;
export const getItemsLikeRecords = ({ itemLikes }) => itemLikes.data;
export const getDeletedItemIds = ({ item }) => Object.keys(item.updatedItems).map((id) => parseInt(id, 10)).filter((id) => item.updatedItems[id].isDeleted === true);
export const getUpdatedItemIds = ({ item }) => Object.keys(item.updatedItems).filter((id) => item.updatedItems[id].isDeleted !== true);
export const getUpdatedItems = ({ item }) => item.updatedItems;
